import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams/createUrlWithParams';

import { Address, AddressUnassigned, DefaultApiResponse } from './_types';

const endpoints = {
  addressData: '/api/v1/address-data/',
};

export type UpdateAddressDataInput = AddressUnassigned;

type UpdateAddressDataQuery = (data: UpdateAddressDataInput) => Promise<DefaultApiResponse<Address>>;

const patients = {
  postAddressData:
    (id: number): UpdateAddressDataQuery =>
    data =>
      axios.post<UpdateAddressDataQuery, DefaultApiResponse<Address>>(`${endpoints.addressData}${id}/`, data),
  putAddressData:
    (id: number): UpdateAddressDataQuery =>
    data =>
      axios.put<UpdateAddressDataQuery, DefaultApiResponse<Address>>(`${endpoints.addressData}${id}/`, data),
  patchAddressData:
    (id: number, isPro: boolean): UpdateAddressDataQuery =>
    data =>
      axios.patch<UpdateAddressDataQuery, DefaultApiResponse<Address>>(
        createUrlWithParams({ url: `${endpoints.addressData}${id}/`, params: { pro: isPro }, removeEmptyParams: true }),

        data,
      ),
};

export default patients;
